<template>
  <div id="app" v-loading='loading'>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    loading () {
      return this.$store.state.loading
    }
  }
}
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  font-size: 16px;
  height: 100%;
}

* {
  font-family: "Microsoft YaHei";
}
</style>



// WEBPACK FOOTER //
// src/App.vue